import { put } from '@redux-saga/core/effects'
import { setThemeOverride } from 'application/redux/actions/form'

export function* setThemeFromAccountPublicInfo(action) {
    const themeOverride = {
        formContainerBackground: action.secondaryColor,
        buttonBackground: action.primaryColor
    }
    yield put(setThemeOverride(themeOverride))
}